// extracted by mini-css-extract-plugin
export default {"Container":"Avatar_Container__A790g","Logo":"Avatar_Logo__4Idul","LogoLetter":"Avatar_LogoLetter__bAHPF"};